import { markRaw, toRaw } from 'vue'
import { createStore } from 'vuex'
import axios from 'axios'
import _env from '../config/dev.env.var'
import * as topojson from "topojson-client"

let env = null;

const state = {
  infoOga: null,
  config_from_api: {},
  browser: null,
  cityCodes: [],
  cityCode: null,
  uid: null,
  showOsm: false, // OpenStreetMapタイルを背景地図の候補に含めるかどうか
  map_version: ["mesh", "district", "el", "jh"],
  thresholds: [],
  map: null,
  geometry: {
    boundaries: {}
  },
  numData: {},
  meshShowFlag: true, // mesh用
  year: 2020, // 初期表示年
  markerLayerRetval: null,
  markerLegends: {},
  markerIconURLs: {},
  markers: {},
  markersRaw: null,
  fetched: {
    markerLegends: false
  },
  circle: null,
  circleRange: 500,
  pieChart: null,
  infoWindowVisible: false, // infoWindowを描画するかどうかのフラグ
  loadingModalVisible: true, // ロード画面を描画するかどうかのフラグ
  selectedMarker: {}, // クリックされたマーカーのデータ
  selectedLayer: 1,
  selectedDataType: 1,
  infoWindowCoord: {
    x: 0,
    y: 0
  },
  mapChangeEvent: 0,
  // mapClickEvent: 0,
  mapClickEvent: null,
  lastColoredMeshes: [],
  dataForInfowindow:null,
  turfLayer:null,
  meshLayer:null,
  features: null,
}

// 非同期処理は actions に記述する．
const actions = {

  // マーカーデータを取得し，leaflet用のオブジェクトを作成
  async fetchMarkers(context, query) {
    // const APIEndpoint = ('csv' in query) ? env.localAPI_markers[query.uid].baseUrl : env.localAPI_markers[query.uid].baseUrl;
    const csv = ('csv' in query) ? query.csv : null;
    const markersAPI= this.state.config_from_api.localAPI_markers[this.state.uid].baseUrl + "/markers"
    await axios.get(markersAPI, {
      params: {
        cityCodes: state.cityCode,
        }
    })
    .then(res => {
      context.commit('setMarkersRaw', res)
    })
    .catch(error => {
      console.log("marker の取得処理に失敗しました．");
      console.log(error);
    });
  },

  async fetchMarkerLegends(context) {
    const localAPIMarkers = context.state.config_from_api.localAPI_markers
    const markerConfig = localAPIMarkers && localAPIMarkers[context.state.uid]
    if (!markerConfig || !markerConfig.baseUrl) {
      return
    }

    const markerLegendsAPI = markerConfig.baseUrl + "/markerLegends"
    await axios.get(markerLegendsAPI, {
      params: {
        cityCodes: context.state.cityCode,
      }
    })
    .then(res => {
      context.commit('setMarkerLegends', res)
    })
    .catch(error => {
      console.log("marker-legends を取得できませんでした。");
      console.log(error);
    })
  },

  // マップの関係ないところをクリックした際の処理
  // mapClickEvent (context) {
  //   // マーカー下の円をremove
  //   if (context.state.infoWindowLoaded == true) {
  //     context.commit('removeLayer', context.state.circle);
  //     context.commit('setCircle', null);
  //     context.commit('chgInfoWindowVisible', false) // これをするとランダムなポイントのクリックが取得されなくなる
  //   }
  //   // context.commit('setPieChart', null);
  // },

  async fetchConfig (context) {
    await axios.get(`${_env.localAPI}/config`, {
      params: {
        city: context.state.cityCode,
        uid: context.state.uid
      }
    }).then(res => {
      context.commit('setConfig', res)
    }).catch(error => {
      console.log("config を取得できませんでした．");
    })
  },

  async fetchInfoOga(context,{year, id}){
    const mapBounds = context.state.map.getBounds()
    await axios.get(`${_env.localAPI}/oga2`,{
      params: {
        year: year,
        id: id,
        mapBounds: mapBounds,
      }
    }).then(res =>{
      console.log("ストアのInfoOga", res.data[0])
      context.commit('setInfoOga', res.data[0])
      console.log("storeの")
      console.log(this.state.infoOga)
    })
  },
  // 統計データ取得
  async fetchNumData (context, args) {
    console.log("fetchNumData start")
    const cityCode = context.state.cityCode
    const selectedLayer = context.state.selectedLayer
    const selectedDataType = context.state.selectedDataType
    const year = context.state.year
    const mapBounds = context.state.map.getBounds()

    await axios.get(`${_env.localAPI}/numData`, {
      params: {
        cityCode: cityCode,
        year: year,
        selectedLayer: selectedLayer,
        selectedDataType: selectedDataType,
        mapBounds: mapBounds,
      }
    }).then(res => {
      if (Object.keys(res.data).length > 0 ) {
        context.commit('setNumData', res.data)
      }
    }).catch(error => {
        console.log("メッシュの統計データの取得処理に失敗しました．");
        console.log(error);
    });
  },
}

const getters = {}

const mutations = {
  setInfoOga(state, data){
    state.infoOga = data
  },
  setBrowserType (state) {
    let agent = window.navigator.userAgent.toLowerCase();
    // if(agent.indexOf('msie') > -1) {
      if(agent.indexOf('trident') > -1) {
      state.browser = 'ie'
      // console.log('IEブラウザです');
    } else if(agent.indexOf('edge') > -1) {
      state.browser = 'edge'
      // console.log('Edgeブラウザです');
    } else if(agent.indexOf('chrome') > -1) {
      state.browser = 'chrome'
      // console.log('Chromeブラウザです');
    } else if(agent.indexOf('safari') > -1) {
      state.browser = 'safari'
      // console.log('Safariブラウザです');
    } else if(agent.indexOf('firefox') > -1) {
      state.browser = 'firefox'
      // console.log('Firefoxブラウザです');
    } else {
      state.browser = 'other'
      // console.log('その他のブラウザです');
    }
  },
  setCityCodes (state, cityCodes) {
    state.cityCodes = cityCodes;
  },
  setSelectedLayer (state, val) {
    state.selectedLayer = val;
  },
  setSelectedDataType (state, val) {
    state.selectedDataType = val;
  },
  setUid (state, uid) {
    state.uid = uid;
  },
  setYear (state, year) {
    state.year = year
  },
  setYearOga (state, year) {
    state.infoOga.year = year
  },
  setThreshold (state, cityName) {
    // state.thresholds = env.cityConfig[cityName].populationThresholds;
    state.thresholds = env.cityConfig.populationThresholds;
  },
  setNumData (state, numData) {
    state.numData = numData ? markRaw(numData) : null
  },
  setMapChangeEvent (state) {
    state.mapChangeEvent = state.mapChangeEvent + 1
  },
  setMapClickEvent (state, event) {
    if (!event || !event.latlng) {
      state.mapClickEvent = null
      return
    }

    state.mapClickEvent = {
      lat: event.latlng.lat,
      lng: event.latlng.lng,
      latlng: {
        lat: event.latlng.lat,
        lng: event.latlng.lng
      },
      stamp: Date.now()
    }
  },
  addLastColoredMeshes (state, meshId) {
    state.lastColoredMeshes.push(meshId);
  },
  resetLastColoredMeshes (state) {
    state.lastColoredMeshes = markRaw([]);
  },
  // メッシュの表示/非表示をスイッチする関数
  switchMeshVisibility (state) {
    state.meshShowFlag = !state.meshShowFlag;
    // vectorTileLayer使用時以下は使えないため廃止
    // const layer = state.polygonLayerRetval
    // if (layer.property) {
    //   layer.eachLayer((layer) => {
    //     layer.eachLayer((layer) => {
    //       // showFlag は true か false
    //       layer.setStyle({fillOpacity: 1*state.meshShowFlag})
    //     })
    //   })
    // }
  },
  setMarkerLegends (state, res) {
    // markerLegendsの初期化
    let markerLegends = {};
    for (const legend of res.data) {
      const pLabel = legend.label; // 親ラベル
      markerLegends[pLabel] = legend;
      markerLegends[pLabel].showFlag = false; // マーカーレジェンドの子要素の表示フラグ

      // markerLegends.itemsの修正
      const items = {};
      for (const item of markerLegends[pLabel].items) {
        const cLabel = item.label; // 子ラベル
        const cCategory = item.category; // 子カテゴリ
        items[cLabel] = item;
        items[cLabel].markerShowFlag = false;

        // アイコンのURLをセット
        state.markerIconURLs[cCategory] = legend.icon.url;
      }
      markerLegends[pLabel].items = items;
    }
    // 一旦別の変数に固めてからstateに代入しないとDOMに反映されない．
    state.markerLegends = markerLegends;
    // このフラグがmarkerコンポーネントのレンダー条件(v-if)
    state.fetched.markerLegends = true;
  },
  // 全マーカーの表示/非表示フラグを true か false に書き換える．
  modMarkerShowFlags (state, flag) {
    for (const pLabel in state.markerLegends) {
      let label = state.markerLegends[pLabel];
      label.markerShowFlag = flag;
      for (const idx in label.items) {
        label.items[idx].markerShowFlag = flag;
      }
    }
  },
  // マーカー子要素の表示/非表示を切り替える．
  toggleShow (state, label) {
    state.markerLegends[label].showFlag = !state.markerLegends[label].showFlag;
  },
  setMap (state, map) {
    state.map = map ? markRaw(map) : null
  },
  // layer または marker を map に追加する．
  addLayer (state, L) {
    const layer = markRaw(toRaw(L))
    const ret = markRaw(layer.addTo(toRaw(state.map)))
    // if (ret.property === "mesh") {
    //   state.meshLayerRetval = ret;
    if (state.map_version.includes(ret.property)) {
      state.polygonLayerRetval = ret;
    }else if (ret.property === "marker") {
      state.markerLayerRetval = ret;
    }
  },
  // layer または marker を map から取り除く．
  removeLayer (state, layer) {
    const map = toRaw(state.map)
    const rawLayer = toRaw(layer)
    if (map && rawLayer) {
      map.removeLayer(rawLayer)
    }
  },
  setBoundaries (state, res) {
    // おそらく topojson を geojsonに変換している．
    state.geometry.boundaries = markRaw(topojson.feature(res.data, res.data.objects.boundaries))
  },
  setMarkersRaw (state, res) {
    state.markersRaw = res ? markRaw(res) : null
  },
  setMarkers (state, markers) {
    state.markers = markers ? markRaw(markers) : {}
  },
  setCircle (state, circle) {
    state.circle = circle ? markRaw(circle) : null
  },
  updateCircle (state) {
    // setRadius は leaflet の関数
    const circle = toRaw(state.circle)
    if (circle) {
      circle.setRadius(state.circleRange)
    }
  },
  updateCircleRenge (state, circleRange) {
    // setRadius は leaflet の関数
    state.circleRange = circleRange;
  },
  setPieChart (state, pieChart) {
    // グラフが重複して描画されているところを修正
    // 一度DOMに紐づいているグラフをdestroyしてから新しいグラフを描画する
    try {
      const currentPieChart = toRaw(state.pieChart)
      if (currentPieChart) {
        currentPieChart.destroy()
      }
    } catch (e) {
      console.log("グラフがありません");
    }
    state.pieChart = pieChart ? markRaw(pieChart) : null
  },
  // updatePieChart (state, data) {
  //   console.log("中身確認")
  //   console.log(state.pieChart.data.datasets[0].data)
  //   state.pieChart.data.datasets[0].data = data;
  //   state.pieChart.update();
  // },
  updatePieChartData (state, data) {
    // pieChart.dataを更新するとグラフの初期化アニメーションが走るため，datasetsの中身だけ差し替える
    // state.pieChart.data = data;
    const pieChart = toRaw(state.pieChart)
    if (!pieChart) {
      return
    }
    pieChart.data.datasets[0].data = data
    pieChart.update()
  },
  displayStyleShow(state, layer){
    const rawLayer = toRaw(layer)
    const element = rawLayer && rawLayer.getElement ? rawLayer.getElement() : null
    if (element) {
      element.style.display = 'block'
    }
  },
  displayStyleNone(state, layer){
    const rawLayer = toRaw(layer)
    const element = rawLayer && rawLayer.getElement ? rawLayer.getElement() : null
    if (element) {
      element.style.display = 'none'
    }
  },
  chgInfoWindowVisible(state, status) {
    state.infoWindowVisible = status
  },
  chgLoadingModalVisible(state, status) {
    state.loadingModalVisible = status
  },
  setSelectedMarker(state, mdata) {
    state.selectedMarker = mdata
  },
  setInfoWindowCoord(state, infoWindowCoord) {
    state.infoWindowCoord = infoWindowCoord
  },
  moveMapCenter(state, args) {
    const deltaVals = {
      18: {lat: 0, lng: 0.01},
      17: {lat: 0, lng: 0.01},
      16: {lat: 0, lng: 0.01},
      15: {lat: 0, lng: 0.02},
      14: {lat: 0, lng: 0.03},
      13: {lat: 0, lng: 0.05},
      12: {lat: 0, lng: 0.1},
      11: {lat: 0, lng: 0.2},
      10: {lat: 0, lng: 0.4},
      9: {lat: 0, lng: 0.6},
      8: {lat: 0, lng: 0.7},
      7: {lat: 0, lng: 0.8},
      6: {lat: 0, lng: 0.9},
      5: {lat: 0, lng: 1},
      4: {lat: 0, lng: 2},
      3: {lat: 0, lng: 3},
      2: {lat: 0, lng: 4},
      1: {lat: 0, lng: 5},
      0: {lat: 0, lng: 6},
    }
    const mapLatLng = {}
    const lat = args.latlng.lat
    const lng = args.latlng.lng
    const zoom = args.zoom
    mapLatLng.lat = lat - deltaVals[zoom]['lat']
    mapLatLng.lng = lng + deltaVals[zoom]['lng']
    const map = toRaw(state.map)
    if (map) {
      map.panTo(mapLatLng)
    }
  },
  setConfig (state, config) {
    env = config.data;
    state.config_from_api = config.data;
  },
  setUrlParams (state) {
    const queryString = [
      window.location.search,
      window.location.hash.includes('?') ? window.location.hash.split('?')[1] : ''
    ].filter(Boolean).join('&').replace(/^\?/, '')
    const kvPairs = queryString ? queryString.split('&') : []
    const paramObj = new Object;

    for (let kvPair of kvPairs) {
      let kv = kvPair.split('=')
      paramObj[kv[0]] = kv[1]
    }

    state.cityCode = paramObj["city"]
    state.uid = paramObj["uid"]
    state.showOsm = isTruthyParam(paramObj, "osm")
  },
  setdataForInfowindow(state, tmpdata) {
    state.dataForInfowindow = tmpdata;
  },
  updateTurfLayer(state, tmplayer) {
    state.turfLayer = tmplayer ? markRaw(tmplayer) : null
  },
  updateMeshLayer(state, tmplayer) {
    state.meshLayer = tmplayer ? markRaw(tmplayer) : null
  },
  setFeatures(state, features) {
    state.features = features ? markRaw(features) : null
  }
}

// GETパラメータを真偽値として解釈する．
// キーが存在すれば真とみなし(`?osm` のように値がない場合も真)，
// 明示的に 0 / false が指定された場合のみ偽とする．
function isTruthyParam (params, key) {
  if (!(key in params)) {
    return false;
  }
  const value = params[key];
  if (value === undefined || value === '') {
    return true;
  }
  return value !== '0' && value.toLowerCase() !== 'false';
}

function initConfig() {
  return store => {
    // store.commit('setUrlParams')
    // store.dispatch('fetchConfig')
  }
}

const plugin = initConfig()

const store = createStore({
  state,
  getters,
  actions,
  mutations,
  plugins: [plugin],
  strict: false,
})

export default store
